import Immutable from 'immutable';

export interface RawIntegrationsDrive {
  id: string;
  key: string;
  lastModified: string;
  name: string;
  type: string;
  updatedAt: string;
}

const defaultValues: RawIntegrationsDrive = {
  id: '',
  key: '',
  lastModified: '',
  name: '',
  type: '',
  updatedAt: '',
};

export const IntegrationsDriveFactory = Immutable.Record(
  defaultValues,
  'IntegrationsDrive'
);

export class IntegrationsDrive extends IntegrationsDriveFactory {
  static deserialize(
    rawIntegrationsDrive: RawIntegrationsDrive
  ): IntegrationsDrive {
    return new IntegrationsDrive(rawIntegrationsDrive);
  }

  serialize(): RawIntegrationsDrive {
    return this.toJS();
  }
}
